
export default function HowItWorksSection() {
  const steps = [
    {
      number: "01",
      title: "Free Consultation",
      description: "We analyze your debt situation and create a personalized settlement strategy at no cost to you.",
      icon: "fas fa-comments"
    },
    {
      number: "02",
      title: "Stop Payments",
      description: "We guide you to stop payments to creditors and start saving money in a dedicated settlement fund.",
      icon: "fas fa-pause-circle"
    },
    {
      number: "03",
      title: "Negotiate Settlement",
      description: "Our licensed professionals negotiate with creditors to reduce your debt by up to 60% or more.",
      icon: "fas fa-handshake"
    },
    {
      number: "04",
      title: "Achieve Freedom",
      description: "Once settlements are reached, you pay the reduced amount and become debt-free faster.",
      icon: "fas fa-trophy"
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It <span className="text-orange-500">Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven 4-step process has helped thousands of Americans eliminate their debt burden and regain financial control.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-8 h-0.5 bg-orange-300 z-0"></div>
              )}
              
              <div className="bg-white rounded-xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                
                <div className="text-3xl font-bold text-orange-500 mb-4">{step.number}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
          >
            Start Your Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
